import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axiosInstance from "./security/axiosInstance";

const queryParams = new URLSearchParams(window.location.search);
const token = queryParams.get("token");

ReactDOM.render(
  <Suspense fallback={<div>Loading...</div>}>
    <React.StrictMode>
      <App
        axiosInstance={axiosInstance}
        token={token}
      />
    </React.StrictMode>
  </Suspense>,
  document.getElementById('root')
);
